import React from 'react';
import { ReadsTable } from '../ReadsTable';

export const Mobile: React.FC = () => {
  return <ReadsTable methodFilter="Mobile" />;
};
